export default () => {
 /** @type {HTMLElement} */
 const MoreOptions=document.querySelector('[d-more-opts]')
 /** @type {HTMLElement} */
 const opts=document.querySelector('[d-opts]')
 MoreOptions.addEventListener('click',()=>{
  opts.style.display='block'
 })
 window.addEventListener('click',(ev)=>{
  if(ev.target==MoreOptions) return
  if(MoreOptions.contains(ev.target)) return
  if(ev.target==opts) return
  if(opts.contains(ev.target)) return

  opts.style.display='none'
 })

 /** @type {HTMLElement} */
 const Main=document.querySelector('[d-main]')
 if(Main) {
  const initial=90
  const min=60
  /** @type {HTMLElement} */
  const WideLogo=document.querySelector('[d-wide-logo]')
  const offset=100
  Main.addEventListener('scroll',(ev)=>{ // main if scroll? ok
   let scrollTop=Main.scrollTop
   if(scrollTop<offset) {
    WideLogo.style.height=initial+'px'
    return
   }
   scrollTop=Math.max(0,scrollTop-offset)
   // WideLogo
   if(scrollTop<200) {
    // if scroll top is 0, then height is 90
    // the more scroll top, the more added. added between 0 and 45
    const ratio=scrollTop/200
    const current=Math.round((initial-min)*ratio)
    WideLogo.style.height=initial-current+'px' // this is between initial 90 and max 45px
    // 0-45 is like 200 to 0
   }else{
    WideLogo.style.height=min+'px'
   }
   // console.log('scroll',Main.scrollTop,ev)
  })
 }

 // can we take the element rather than the function? it's possible to export
 // component after which it will be open only when scrolled into like with faq
 // and youtube but here...?
 /** @type {HTMLElement} */
 const MobMenu=document.querySelector('[d-mob-menu]')
 const MobMenuBtn=document.querySelector('[d-mob-menu-btn]')
 let open=false
 const flip=()=>{
  if(open) {
   MobMenu.style.setProperty('display','none','important')
  }else{
   MobMenu.style.removeProperty('display')
  }
  open=!open
 }
 MobMenuBtn.addEventListener('click',(ev)=>{
  ev.stopPropagation()
  flip()
  return false
 })
 document.addEventListener('click',()=>{
  if(open) flip()
 })

 document.querySelector('[d-mob-wa]').addEventListener('click',()=>{
  if(window['ym']) {
   window['ym'](89137587,'reachGoal','MobMenuWhatsApp')
  }
 })

 document.querySelector('[d-mob-phone]').addEventListener('click',()=>{
  if(window['ym']) {
   window['ym'](89137587,'reachGoal','MobMenuPhone')
  }
 })

 document.querySelector('[d-desk-wa]').addEventListener('click',()=>{
  if(window['ym']) {
   window['ym'](89137587,'reachGoal','DeskMenuWhatsApp')
  }
 })

 document.querySelector('[d-desk-phone]').addEventListener('click',()=>{
  if(window['ym']) {
   window['ym'](89137587,'reachGoal','DeskMenuPhone')
  }
 })
}